export class Orgao {
    idOrgao: number;
    siglaOrgao: string;
    nomeOrgao: string;
    prioridadeOrgao?: number;
    label?: string;
}
